import "./style.css";
import "./app.css";
import { startApp } from "./ui/app";

const root = document.querySelector<HTMLDivElement>("#app");
if (!root) throw new Error("#app mount point missing from index.html");

startApp(root);
